export enum EntityTypes {
  dashboard = 'dashboard',
  query = 'query',
  api = 'api',
  table = 'table',
}